
import axios from 'axios';

export const getWhiseOfficeListService = async (whiseUserToken, clientId) => {
    try {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        //await axios.post(url, { }, config)
        const response = await axios.post(url, { "clientId": clientId }, config);
        if (response.data.offices != undefined) {
            return response.data.offices;
            console.log(response.data.offices);
            //const updateOfficeList = response.data.offices.map((item) => ({ ...item, Id: item.id }));
            //setOfficeList(updateOfficeList);
            //var _filteredOffice = updateOfficeList.filter((item) => { return item.id == officeId });
            //setOffice(_filteredOffice[0]);
            //setSelectOffice(_filteredOffice[0].id);
            //getOfficesLogo(_filteredOffice[0].id);
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

